import * as THREE from 'three'

class ScenepParameter{
  constructor(){
    this.modelName = 'sample1'
    this.modelPath = this.getModelPath();

    this.defaultMaterial = "MeshLambertMaterial";
    
    this.bEnableDirLight = true;
    this.bEnableDirLightShadow = true;
    this.dirLightIntensity = 1;

    this.bEnableAmbientLight = true;
    this.ambientLightIntensity = 0.2;

    this.envIntensity = 0.4;

    this.cubemapName = 'StdSky_IEM';
    this.cubemapPath = this.getCubemapPath();

    this.initCameraPos = new THREE.Vector3(-34.7670984113749,  22.58222569673183, 44.67206054678795);
    this.initCameraTarget = new THREE.Vector3(40, 0, 1);

    this.subDirLightIntensity = 0.2;
    
    this.setInitParamsModelParams();
  }

  getModelPath(){
    let path = '/assets/'
    if(this.modelName == 'sample0')
      path = path+'sample0.glb'
    else if(this.modelName == 'sample1')
      path = path+'sample1.glb'
    else if(this.modelName == 'sample2')
      path = path+'sample2.glb'

    return path;
  }

  getCubemapPath(){
    let path = '/assets/'
    if(this.cubemapName == 'TAKO_Park_Bridge01_IEM')
      path += 'TAKO_Park_Bridge01_IEM/';
    else if(this.cubemapName == 'NR_Parking_IEM')
      path += 'NR_Parking_IEM/';
    else if(this.cubemapName == 'YK_OOSANBASI_IEM')
      path += 'YK_OOSANBASI_IEM/';
    else if(this.cubemapName == 'StdSky_IEM')
      path += 'StdSky_IEM/'
    
    return path;
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  setInitParamsModelParams(){
    // get init parameters from query ?model=AAA&shadow=true
    const modelName = this.getParameterByName('modelName');
    const defaultMaterial = this.getParameterByName('defaultMaterial');
    const bEnableDirLight = this.getParameterByName('bEnableDirLight');
    const bEnableDirLightShadow = this.getParameterByName('bEnableDirLightShadow');
    const dirLightIntensity = this.getParameterByName('dirLightIntensity');
    const bEnableAmbientLight = this.getParameterByName('bEnableAmbientLight');
    const ambientLightIntensity = this.getParameterByName('ambientLightIntensity');
    const envIntensity = this.getParameterByName('envIntensity');
    const cubemapName = this.getParameterByName('cubemapName');
    const subDirLightIntensity = this.getParameterByName('subDirLightIntensity');
   
    if(modelName !== null){
      this.modelName = modelName
      this.modelPath = this.getModelPath();
    }

    if(defaultMaterial !== null)
      this.defaultMaterial = defaultMaterial;
    if(bEnableDirLight !== null)
      this.bEnableDirLight = bEnableDirLight === 'true' ? true : false;
    if(bEnableDirLightShadow !== null)
      this.bEnableDirLightShadow = bEnableDirLightShadow === 'true' ? true : false;
    if(dirLightIntensity !== null)
      this.dirLightIntensity = parseFloat(dirLightIntensity);
    if(bEnableAmbientLight !== null)
      this.bEnableAmbientLight = bEnableAmbientLight === 'true' ? true : false;
    if(ambientLightIntensity !== null)
      this.ambientLightIntensity = parseFloat(ambientLightIntensity);
    if(envIntensity !== null)
      this.envIntensity = parseFloat(envIntensity);

    if(cubemapName !== null){
      this.cubemapName = cubemapName
      this.cubemapPath = this.getCubemapPath();
    }

    if(subDirLightIntensity !== null)
      this.subDirLightIntensity = parseFloat(subDirLightIntensity);
  }

}

export default new ScenepParameter();
